
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { AutoSuggestInput, Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { defaultArgWith, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Select } from "../../Components/Select.js";
import { singleton as singleton_1, append as append_1, ofArray, tryFind, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Hierarchy_getPath } from "../../Shared/Location.js";
import { equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function EmployeeForm(props) {
    const t = useTranslation()[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: formState,
            Label: t("general.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "employee-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Employee.Name,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: formState,
            Label: t("user.personnel_number"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(1, [arg_1]));
            },
            TestId: "employee-personnel-number",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "personnel_number")),
            Value: props.Employee.PersonnelNumber,
        })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (value) => {
                props.Dispatch(new Msg(8, [value]));
            },
            SelectedBusinessUnitId: unwrap(props.Employee.BusinessUnitId),
        })) : empty()) : empty(), delay(() => {
            let Label_2, Value_2;
            return append(isFeatureEnabled(new Feature(15, [])) ? singleton(createElement(Input, (Label_2 = t("general.email"), (Value_2 = defaultArg(props.Employee.Email, ""), {
                ComponentState: formState,
                Label: unwrap(Label_2),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(3, [arg_2]));
                },
                TestId: "employee-email",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                Value: Value_2,
            })))) : empty(), delay(() => {
                let dependencies_1;
                return append(singleton((dependencies_1 = [props.Employee.Department, props.DepartmentSuggestions, formState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                    ComponentState: formState,
                    Label: t("user.department"),
                    OnChange: (arg_3) => {
                        props.Dispatch(new Msg(2, [arg_3]));
                    },
                    Suggestions: props.DepartmentSuggestions,
                    TestId: "employee-department",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "department")),
                    Value: props.Employee.Department,
                }), dependencies_1))), delay(() => {
                    let Label_4, Options, Value_4, matchValue, locationId;
                    return append(singleton(createElement(Select, (Label_4 = t("general.location"), (Options = map((location) => ({
                        label: Hierarchy_getPath(props.Locations, location),
                        value: location,
                    }), props.Locations), (Value_4 = ((matchValue = props.Employee.LocationId, (matchValue == null) ? undefined : ((locationId = matchValue, map_1((location_3) => ({
                        label: Hierarchy_getPath(props.Locations, location_3),
                        value: location_3,
                    }), tryFind((location_2) => equals(location_2.Id, locationId), props.Locations)))))), {
                        ComponentState: formState,
                        IsClearable: true,
                        Label: unwrap(Label_4),
                        NoOptionsMessage: "select.location_no_options",
                        OnChange: (location_1) => {
                            props.Dispatch(new Msg(4, [map_1((_arg_1) => _arg_1.value.Id, location_1)]));
                        },
                        Options: Options,
                        PlaceholderKey: "select.location_placeholder",
                        TestId: "employee-location",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "location")),
                        Value: unwrap(Value_4),
                    }))))), delay(() => (props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                        Currency: props.CustomerConfiguration.Currency,
                        CustomProperties: props.Employee.CustomProperties,
                        FormState: props.FormState,
                        OnSetCustomProperty: (arg_4) => {
                            props.Dispatch(new Msg(5, [arg_4]));
                        },
                        PropertyConfigurationType: new PropertyConfigurationVisibility(3, []),
                        PropertyConfigurations: props.PropertyConfigurations,
                    })) : empty())));
                }));
            }));
        })))))))),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewEmployeeView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.PropertyConfigurations;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.Departments;
    const matchValue_4 = state_1.Locations;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, departments, employee, isCustomPropertiesEnabled, locations, propertyConfigurations;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        departments = matchValue_3.fields[0];
        employee = matchValue.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_4.fields[0];
        propertyConfigurations = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(EmployeeForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                DepartmentSuggestions: departments,
                Dispatch: dispatch,
                Employee: employee,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("employee.create_new_employee"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["receivers", "employees" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(6, []));
                },
                PropertyConfigurations: propertyConfigurations,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditEmployeeView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.EmployeeId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.PropertyConfigurations;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.Departments;
    const matchValue_4 = state_1.Locations;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, departments, employee, isCustomPropertiesEnabled, locations, propertyConfigurations;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        departments = matchValue_3.fields[0];
        employee = matchValue.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_4.fields[0];
        propertyConfigurations = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(EmployeeForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                DepartmentSuggestions: departments,
                Dispatch: dispatch,
                Employee: employee,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("employee.edit_employee"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map_1((tupledArg) => {
                        RouterModule_nav(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnSave: () => {
                    dispatch(new Msg(7, []));
                },
                PropertyConfigurations: propertyConfigurations,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

